// extracted by mini-css-extract-plugin
module.exports = {"btnResendVerification":"sign_in_btnResendVerification__rZcNF"};